import { createSelector } from "reselect";
import getUserAgent from "selectors/device/getUserAgent";

export default createSelector(
  [getUserAgent],
  (userAgent) => !userAgent.isDesktop,
);
